/** @jsxImportSource @emotion/react */
import React from "react";
import { effects } from "../../components/effects";
import { colors } from "../../components/colors";
import { css } from "@emotion/react";

const dropdownStyle = css`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  gap: 8px;
  background-color: ${colors.white};
  box-shadow: ${effects.popover};
  border-radius: 4px;
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const DropdownMenuWrapper = ({ children, ...rest }: Props) => {
  return (
    <div css={dropdownStyle} {...rest}>
      {children}
    </div>
  );
};
